define([
    "./monitoringIntegrationModule",
], function (module) {
    "use strict";

    module.config(["$stateProvider", function ($stateProvider) {

        $stateProvider
            .state("monitoring.integration", {
                url: "/integration",
                template: "<nlg-Monitoring-Integration-Url-Configuration></nlg-Monitoring-Integration-Url-Configuration>",
                data: {
                    group: "group.monitoring.restriction.configuration",
                    pageTitle: "{{'title.monitoring.logRecord' | translate:$stateParams}}"
                }
            })
    }]);
});
